import $ from 'jquery';

;(function($) {
  $.fn.rwdImageMaps = function() {
    const $img = this;
    
    const rwdImageMap = function() {
      $img.each(function() {
        if (typeof($(this).attr('usemap')) === 'undefined') return
        
        const that = this
        const $that = $(that)
        
        $('<img />').on('load', function() {
          let maxWidth = 640
          let thisWidth = $that.width()
          let percent = (thisWidth / maxWidth)
          let map = $that.attr('usemap').replace('#', '')
          let c = 'coords'
          
          $('map[name="' + map + '"]').find('area').each(function() {
            const $this = $(this)

            if (!$this.data(c)) {
              $this.data(c, $this.attr(c))
            }
            
            const coords = $this.data(c).split(',')
            const coordsPercent = new Array(coords.length)
            
            for (let i = 0; i < coordsPercent.length; ++i) {
              coordsPercent[i] = +coords[i] * percent
            }

            $this.attr(c, coordsPercent.toString())

          })
        }).attr('src', $that.attr('src'))
      })
    }

    $(window).resize(rwdImageMap).trigger('resize')
    
    return this
  }
})($);
